import React, { useState } from 'react';

const AccordionItem = ({ title, children }) => {
    const [isActive, setIsActive] = useState(false);

    const toggleAccordion = () => {
        setIsActive(!isActive);
    };

    return (
        <div className="accordion-item">
            <div className={`accordion-header ${isActive ? 'active' : ''}`} onClick={toggleAccordion}>
                {title}
            </div>
            <div className="accordion-content" style={{ display: isActive ? 'block' : 'none' }}>
                {children}
            </div>
        </div>
    );
};

export default AccordionItem;
